module.exports = __webpack_public_path__ + "img/comingsoon.b0ce2012.svg";